export const VOLUNTEER_ORGANIZER = [
  {
    name: "Jamie Seoh",
    title: "Volunteer Logistics Organizer",
    phone: "905-236-1207",
    email: "jamie@hackthenorth.com",
  },
];

export const VOLUNTEER_LEADS = [
  {
    name: "Atta Amoah-Bediako",
    title: "Floor Patrol, Security & Sleep",
    phone: "647-870-1627",
    email: "atta@hackthenorth.com",
  },
  {
    name: "Carolyn Zhang",
    title: "Food",
    phone: "613-879-5188",
    email: "carolyn@hackthenorth.com",
  },
  {
    name: "Cindy Miao",
    title: "Ceremonies",
    phone: "416-986-2227",
    email: "cindy@hackthenorth.com",
  },
  {
    name: "Demir Eren",
    title: "Activities & Mentorship",
    phone: "647-518-2308",
    email: "demir@hackthenorth.com",
  },
  {
    name: "Diya Dang",
    title: "Floor Patrol, Security & Decor",
    phone: "647-510-8151",
    email: "diya.dang@hackthenorth.com",
  },
  {
    name: "Elaine Zhu",
    title: "Food",
    phone: "437-340-8124",
    email: "elaine.zhu@hackthenorth.com",
  },
  {
    name: "Nadeen Findakly",
    title: "Registration & Judging",
    phone: "416-227-1340",
    email: "nadeen@hackthenorth.com",
  },
  {
    name: "Saad El-ghazal",
    title: "Hardware & Reception",
    phone: "226-237-2038",
    email: "saad@hackthenorth.com",
  },
  {
    name: "Yashika Somani",
    title: "Workshops",
    phone: "226-507-2657",
    email: "yashika@hackthenorth.com",
  },
];
